import React from 'react';

import { Helmet } from 'react-helmet';

import { Box, Container } from '@mui/material';

import useQuery from '~/hooks/useQuery';

import usePromoMeta from '../Promo/hooks/usePromoMeta';

import PromoDevModeSwitch, { useNewPromoForm } from './PromoDevModeSwitch';
import PromoFormV3 from './PromoFormV3';
import PromoFormV4 from './PromoFormV4';

function PromoContainer() {
  const { promoMeta, promoCodeConditionTypeConfig, isPromoMetaLoading } = usePromoMeta();
  const query = useQuery();
  const newForm = useNewPromoForm();
  return (
    <Container>
      <Helmet>
        <title>Promo Form V4</title>
      </Helmet>
      {!newForm ? (
        <PromoFormV3
          promoCode={null}
          promoMeta={promoMeta}
          isPromoMetaLoading={isPromoMetaLoading}
          promoCodeConditionTypeConfig={promoCodeConditionTypeConfig}
          isDev={newForm}
        />
      ) : (
        <PromoFormV4 promoCodeId={null} promoCodeName={null} isDev={newForm} />
      )}
      <Box>
        <PromoDevModeSwitch />
      </Box>
    </Container>
  );
}

export default PromoContainer;
